import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  DxButtonModule,
  DxDrawerModule,
  DxDropDownButtonModule,
  DxFormModule,
  DxListModule,
  DxScrollViewModule,
  DxToolbarModule,
} from 'devextreme-angular';
import { environment } from '../environments/environment';
import { CoreModule } from './@core/core.module';
import { LayoutModule } from './@ui';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    CoreModule,
    AppRoutingModule,
    LayoutModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    DxDrawerModule,
    DxListModule,
    DxToolbarModule,
    DxScrollViewModule,
    DxDropDownButtonModule,
    DxButtonModule,
    DxFormModule,
    BrowserAnimationsModule,
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
